// extracted by mini-css-extract-plugin
export var pillWrapper = "_om-0";
export var showOverflow = "_om-1";